export default __webpack_public_path__ + "static/media/push18.e618a69b.gif";